// extracted by mini-css-extract-plugin
export default {"container":"BoxCollapse_container__fEDky","enabled":"BoxCollapse_enabled__ohxym"};